import PropTypes from 'prop-types';
import styles from './Location.module.scss';
import { useEffect, useRef } from 'react';
import { logWithPrefix } from 'client/utils/logging';

const log = logWithPrefix('Search');

const Location = ({ feature, isSelected, onSelect, ...props }) => {
    const ref = useRef(null);

    const handleClick = (feature) => {
        const startTime = performance.now();
        const name = feature?.properties?.displayText;
        const lat = feature?.geometry?.coordinates[1];
        const lon = feature?.geometry?.coordinates[0];

        onSelect(feature);

        const endTime = performance.now();
        const searchTime = endTime - startTime;
        log('Search', `Clicked a search result: ${name}, Latitude: ${lat}, Longitude: ${lon}, took: ${searchTime.toFixed(2)} ms`);
    };

    useEffect(() => {
        if (isSelected) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [isSelected]);

    return <div
        className={[styles.location, isSelected ? styles.selected : null].join(' ')}
        role='button'
        onClick={() => handleClick(feature)}
        tabIndex={-1}
        ref={ref}
        data-testid={props['data-testid']}
    >
        {feature?.properties?.type ? <span data-testid="location.label" className={['govuk-body-s', styles.type].join(' ')}>{feature?.properties?.type}</span> : null}
        <p className="govuk-body-m">{feature?.properties?.displayText}</p>
    </div>;
};

Location.propTypes = {
    feature: PropTypes.object,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func,
    'data-testid': PropTypes.string
};

Location.defaultProps = {
    feature: {},
    isSelected: false,
    onSelect: () => {},
    'data-testid': ''
};

export default Location;
